import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../custom/StateProvider';
//import {contentPermissions} from "../../custom/feathersAuthorisation";
import Deposit from './components/deposits';
import {API} from "../../../config";
import {FilteringState, IntegratedFiltering, SortingState, IntegratedSorting} from "@devexpress/dx-react-grid";
import {Grid, VirtualTable, TableFilterRow, TableHeaderRow} from "@devexpress/dx-react-grid-material-ui";
import Utils from "../../custom/utils";
import DepositProof from "../investors/components/depositProof";
import {connect} from "react-redux";

const inbound = API.service('inbound-transfers');

const moment = require('moment');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    header:{
        backgroundColor:"#262933",
        padding:'18px',
        paddingTop:'17px',
        color:'white'
    }
});

class Inbound extends Component {
    state = {
        inbound: [],
    }

    fetchData = () => {
        const app = this;
        if(this.nameSearch !== ''){
            
        }

        inbound.find({query:{incl:['investor']}}).then(inv =>{
          let inbound = [];
            inv.data.forEach((v)=>{
              if((!Utils.isEmpty(this.props.user.affiliate)&& v.investors[0]._affiliate === this.props.user.affiliate) || Utils.isEmpty(this.props.user.affiliate)) {
                inbound.push(v);
              }
            });
          app.setState({
            inbound:inbound
          })
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    componentDidMount = () => {
        this.fetchData();
    }

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
            <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    depositState(state) {
        let states = Utils.returnDepositState(state)
        return(
            <div className={'deposit-label ' + states[0]}>{states[1]}</div>
        )
    }

    getAmountWithCurrency(amount, currencyType){
        let currency = Utils.getCurrency(currencyType.toUpperCase());
        return (currency.currency_symbol + Utils.addThousandCommas(amount, '0,0.00').toString())
    }

    render() {

        const {classes} = this.props;

        return (
          <React.Fragment>
              <div className={classes.header}>
                  <h4>Inbound Deposits</h4>
              </div>
              <Grid
                rows={this.state.inbound}
                columns={[
                    { name: '_timestamp', title: 'Date', getCellValue: row => (row._timestamp ? moment(row._timestamp).format('YYYY-MM-DD'): undefined)  },
                    { name: '_account', title: 'Account' },
                    { name: '_name', title: 'Name', getCellValue: row => (row.investors ? row.investors[0]._firstname + ' ' + row.investors[0]._surname: undefined) },
                    { name: '_email', title: 'Email', getCellValue: row => (row.investors ? row.investors[0]._email: undefined) },
                    { name: '_state', title: 'State', getCellValue: row => (row.investors ? this.investorState(row.investors[0]._states): undefined) },
                    { name: '_fund_type', title: 'Fund Type' },
                    { name: '_transactionid', title: 'Transaction ID' },
                    { name: '_amount', title: 'Amount', getCellValue: row=> (this.getAmountWithCurrency(row._amount_expected, row._currency)) },
                    { name: '_fees', title: 'Fees', getCellValue: row=> (this.getAmountWithCurrency(row._fees_paid, row._currency)) },
                    { name: '_currency', title: 'Currency' },
                    { name: '_status', title: 'Status', getCellValue: row => (row._status ? this.depositState(row._status): undefined) },
                    { name: '_bank_note', title: 'Bank Note' },
                    { name: '_deposit_proof', title: 'Upload', getCellValue: row =>  (<DepositProof depId={row._id} investor={row} />) },
                    { name: '_action', title: 'Actions', getCellValue: row=>(<Deposit row={row} />)
                    },

                ]}>
                  <SortingState
                    defaultSorting={[{ columnName: '_timestamp', direction: 'desc' }]}
                  />
                  <IntegratedSorting />
                  <FilteringState defaultFilters={[]} />
                  <IntegratedFiltering />
                  <VirtualTable height={"auto"}/>
                  <TableHeaderRow showSortingControls />
                  <TableFilterRow />
              </Grid>
          </React.Fragment>
        );
    }
}
function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Inbound))));
